import { render, staticRenderFns } from "./SoundHint.vue?vue&type=template&id=a614290e&scoped=true"
import script from "./SoundHint.vue?vue&type=script&lang=js"
export * from "./SoundHint.vue?vue&type=script&lang=js"
import style0 from "./SoundHint.vue?vue&type=style&index=0&id=a614290e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a614290e",
  null
  
)

export default component.exports